import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-submission',
  templateUrl: './app-submission.component.html'
})
export class AppSubmissionComponent {

  @Input()
  formIsValid: boolean;

}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/submission/app-submission.component.ts